import { Routes } from './components/Routes';
import { DataFetchingClient, DataFetchingClientProvider } from 'data-fetching-client';
import { initializePortal } from 'portals-platform-lib';
import { PortalDataProvider } from './context/PortalDataContext';
import { createRpcClientV2 } from 'rpc-client-utils';
import portalsHttpClient from 'portals-platform-lib/portalsHttpClient';
import { loginVerifyRpc } from '../__generated__/chirp/com/hubspot/portals/platform/app/rpc/AccessRpc';
import { jsx as _jsx } from "react/jsx-runtime";
const chirpClient = createRpcClientV2({
  hubHttpClient: portalsHttpClient
});
export const prepareApp = async () => {
  try {
    const {
      portalData
    } = await initializePortal();
    return {
      props: {
        portalData
      }
    };
  } catch (error) {
    console.error('Failed to fetch brand and theme data:', error);
  }
  return {};
};
export const getLocaleInfo = async () => {
  var _loginData$preferredL;
  const searchParams = new URLSearchParams(window.location.search);
  const localeOverride = searchParams.get('localeOverride');
  if (localeOverride) {
    return {
      langEnabled: true,
      locale: localeOverride
    };
  }
  const loginData = await chirpClient.call(loginVerifyRpc, {
    request: {}
  }).catch(e => {
    console.error(e);
    return undefined;
  });
  const locale = (_loginData$preferredL = loginData === null || loginData === void 0 ? void 0 : loginData.preferredLanguage) !== null && _loginData$preferredL !== void 0 ? _loginData$preferredL : navigator.language;
  return {
    langEnabled: true,
    locale
  };
};
const client = new DataFetchingClient();
export function AppComponent(props) {
  return /*#__PURE__*/_jsx(DataFetchingClientProvider, {
    client: client,
    children: /*#__PURE__*/_jsx(PortalDataProvider, {
      initialData: props.portalData,
      children: /*#__PURE__*/_jsx("div", {
        "data-test-id": "app",
        children: /*#__PURE__*/_jsx(Routes, {})
      })
    })
  });
}